// Full date + time in the viewer's local timezone, formatted the way monday
// shows update timestamps on hover, e.g. "Jul 15, 2026, 3:42 PM". Used as the
// tooltip content behind the relative label. `toLocaleString` defaults to the
// browser's timezone, so no explicit timeZone option is needed.
export const absoluteTime = (iso: string): string => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const relativeTime = (iso: string): string => {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const secs = Math.round((Date.now() - then) / 1000);
  const table: [number, string][] = [
    [60, "m"],
    [60, "h"],
    [24, "d"],
    [7, "w"],
  ];
  let value = secs;
  let unit = "s";
  for (const [step, label] of table) {
    if (Math.abs(value) < step) break;
    value = Math.round(value / step);
    unit = label;
  }
  return value <= 0 && unit === "s" ? "now" : `${value}${unit} ago`;
};
